import O1HD from "../../../../engines/gameEngine";
import getPeopleMap from "../../config/WeChatPeopleConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatPeople } from "../../manager/WeChatConst";
import backpackStallItem from "./backpackStallItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class backpackStallPrfab extends cc.Component {

    @property({type:cc.Node,displayName:"npcContent"})
    npcContent:cc.Node = null;

    @property({type:cc.Prefab,displayName:"npc预制体"})
    npcItem:cc.Prefab = null;

    onLoad(){
        this.loadPage();
    }

    completeFun:(npc:WeChatPeople)=>void = null;

    bindComplete(complete:(npc:WeChatPeople)=>void){
        this.completeFun = complete;
    }

    async loadPage(){
        let peoples = NormalGameManager._instance.weChatManager.getPeoples();
        for(let p of peoples){
            await new Promise<void>(resolve=>{
                let pName:string = p.peopleId;
                let pConfig:WeChatPeople = getPeopleMap()[pName];
                let item:cc.Node = cc.instantiate(this.npcItem);
                let is = item.getComponent(backpackStallItem);
                is.bindData(pConfig,this);
                item.setParent(this.npcContent);
                this.scheduleOnce(resolve);
            });
        }
    }

    currentSelectItem:backpackStallItem = null;

    onSelectOnePeople(oneItem:backpackStallItem){
        if(this.currentSelectItem){
            this.currentSelectItem.hideSelect();
        }
        this.currentSelectItem = oneItem;
        oneItem.setSelect();
    }

    onBtnSelect(e:cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(!this.currentSelectItem){
            O1HD.getModules().uiControlModule.showMessageBox("请先选择赠送对象");
            return;
        }
        this.completeFun && this.completeFun(this.currentSelectItem.npc);
        this.closeThis();
    }

    onBtnCloseThis(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }
}
